import {
    LIST_TEXT_QUESTIONS_START,
    LIST_TEXT_QUESTIONS_SUCCESS,
    LIST_TEXT_QUESTIONS_FAILED
} from '../../../constants';
import { LIST_TEXT_QUESTIONS_URL } from '../../../../../config/constants';
import { ApiBase } from '../../../../utils/apiBase';
import { withType } from '../../../../utils/actionOperations';
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';

export const listTextQuestions = (payload) => {
    const apiBaseInstance = new ApiBase();
    return dispatch => {
        dispatch(withType(LIST_TEXT_QUESTIONS_START, {}));
        apiBaseInstance.instance
            .post(LIST_TEXT_QUESTIONS_URL, { ...payload, ...getProjectIdAndOrgId(payload) })
            .then(response => {
                dispatch(withType(LIST_TEXT_QUESTIONS_SUCCESS, {
                    data: response.data,
                    message: response.message
                }));
            })
            .catch(err => {
                dispatch(withType(LIST_TEXT_QUESTIONS_FAILED, {
                    error: err
                }));
            });
    };
};

